import { Field } from 'Util/Query';

export class MiercuriQuery {
    getData() {
        return new Field('getPromotionDaysPageData')
            .addFieldList(this.getDataFields());
    }

    getDataFields() {
        return [
            'is_active',
            'start_date',
            'end_date',
            'today',
            'banner_image',
            'banner_image_inactive',
            'banner_link',
            'promotion_conditions',
            'conditions_expanded',
            'title',
            'products_widget'
        ];
    }
}

export default new MiercuriQuery();
